module.exports = __webpack_public_path__ + "static/tv170-6da4b3c0b1e667ba4626d02886ad29db.svg";